import React, {useEffect, useState} from 'react';
import {Column, Pie} from "@ant-design/plots";
import {DatePicker, Select} from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import {API_PATH} from "../../components/const";
import axios from "axios";
import {toast} from "react-toastify";

const dateFormat = 'YYYY-MM-DD';

const {RangePicker} = DatePicker;


const ServiceTime1 = () => {
    const [time, setTime] = useState(new Date());
    const [data, setData] = useState([])
    const [dataTotal, setDataTotal] = useState(0)
    const [offices, setOffices] = useState([])
    const [selectOffices, setSelectOffices] = useState(null)
    const [firstDay, setFirst] = useState("")
    const [parents, setParents] = useState([])

    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    const config = {
        data,
        isStack: true,
        xField: 'name',
        yField: 'value',
        seriesField: 'type',

        color:[ '#5664D2', '#FA854F', '#FC53F5', ],

        label: {
            position: 'middle',
            layout: [
                {
                    type: 'interval-adjust-position',
                },
                {
                    type: 'interval-hide-overlap',
                },
                {
                    type: 'adjust-color',
                },
            ],
        },
        colorField: 'type', // or seriesField in some cases

    };
    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                if ( res?.data?.length > 0){
                    setSelectOffices(res?.data[0]?.id)
                } else {
                    setSelectOffices(null)
                }
                if (res?.data?.items?.length > 0) {
                    axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate() + "&branch_id=" + (selectOffices !== null ? selectOffices : res?.data?.items[0]?.id) + "&event_type=customer", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                        .then((res2) => setData(res2?.data?.map(item => {
                            return {
                                ...item,
                                value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                                name: item?.username,
                                type: item?.type,
                            }
                        })))
                }
            })
            .catch(err => {
                // toast.error("Ошибка")
            })
    }
    function onChange(date, dateString) {
        if (dateString !== "") {
            axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + dateString + "&branch_id=" +   selectOffices  + "&event_type=customer", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((res2) => {
                    setData(res2?.data?.map(item => {
                        return {
                            ...item,
                            value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                            name: item?.username,
                            type: item?.type,
                        }
                    }))
                })

            setFirst(dateString)
        } else {
            axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate() + "&branch_id=" + selectOffices + "&event_type=customer", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((res2) => setData(res2?.data?.map(item => {
                    return {
                        ...item,
                        value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                        name: item?.username,
                        type: item?.type,
                    }
                })))
        }
    }

    const onChangeBuild = (e) => {
        setSelectOffices(e)
        axios.get(API_PATH + "deepstream/company/" + localStorage.getItem('id') + "/ds_analytics/employee/workplace-analysis?date_str=" + firstDay + "&branch_id=" +   e + "&event_type=customer" , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then((res2) => setData(res2?.data?.map(item => {
                return {
                    ...item,
                    value: Math.floor(item?.totalDurationInMinutes ? item?.totalDurationInMinutes : 0),
                    name: item?.username,
                    type: item?.type,
                }
            })))
    }
    useEffect(() => {
        setFirst(time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + time?.getDate())
        getBuilding()
        getParentBuilding()
    }, []);

    return (
        <div>
            <div className="chart-box mt-3">
                <div className="visitor-title">
                    <h1><span>
                 Время обслуживания
                </span>

                        <div className="d-flex">
                            <Select
                                showSearch
                                placeholder="Выберите раздел"
                                optionFilterProp="children"
                                className="mr-16"
                                style={{width: "200px"}}
                                onSearch={getParentBuilding}
                                onChange={(e) => getBuilding(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={parents?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                            <Select
                                showSearch
                                placeholder="Выберите филиал"
                                optionFilterProp="children"
                                className="mr-16"
                                onSearch={getBuilding}
                                value={selectOffices}
                                style={{width: "200px"}}
                                onChange={(e) => {
                                    onChangeBuild(e)
                                }}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={offices?.map((item) => {
                                    return {
                                        value: item.building_id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                            <DatePicker
                                placeholder="Выберите дату"
                                format={dateFormat}
                                defaultValue={dayjs(moment().format('YYYY-MM-DD'))}
                                style={{width: "260px"}}
                                onChange={onChange}/>
                        </div>
                    </h1>
                </div>

                <Column {...config} />
            </div>
        </div>
    );
};

export default ServiceTime1;